var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecureSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2843 10.575C14.9181 10.575 14.6212 10.8719 14.6212 11.2382V14.4712H21.3791V11.2382C21.3791 10.8719 21.0822 10.575 20.7159 10.575H15.2843ZM22.5791 14.4712V11.2382C22.5791 10.2092 21.7449 9.375 20.7159 9.375H15.2843C14.2553 9.375 13.4212 10.2092 13.4212 11.2382V14.4712H11.3685C10.3395 14.4712 9.50537 15.3054 9.50537 16.3343V24.0004C9.50537 25.0294 10.3395 25.8636 11.3685 25.8636H24.6317C25.6607 25.8636 26.4948 25.0294 26.4948 24.0004V16.3343C26.4948 15.3054 25.6607 14.4712 24.6317 14.4712H22.5791ZM11.3685 15.6712C11.0023 15.6712 10.7054 15.9681 10.7054 16.3343V24.0004C10.7054 24.3667 11.0023 24.6636 11.3685 24.6636H24.6317C24.9979 24.6636 25.2948 24.3667 25.2948 24.0004V16.3343C25.2948 15.9681 24.9979 15.6712 24.6317 15.6712H11.3685Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2738 18.9209C17.0503 19.2189 16.8943 19.658 16.8943 20.1686C16.8943 20.6792 17.0503 21.1184 17.2738 21.4163C17.4971 21.7141 17.7599 21.8423 17.9996 21.8423C18.2393 21.8423 18.5021 21.7141 18.7254 21.4163C18.9489 21.1184 19.1049 20.6792 19.1049 20.1686C19.1049 19.658 18.9489 19.2189 18.7254 18.9209C18.5021 18.6231 18.2393 18.4949 17.9996 18.4949C17.7599 18.4949 17.4971 18.6231 17.2738 18.9209ZM16.3138 18.2009C16.7076 17.6758 17.2975 17.2949 17.9996 17.2949C18.7017 17.2949 19.2916 17.6758 19.6854 18.2009C20.0791 18.7258 20.3049 19.4235 20.3049 20.1686C20.3049 20.9137 20.0791 21.6114 19.6854 22.1363C19.2916 22.6615 18.7017 23.0423 17.9996 23.0423C17.2975 23.0423 16.7076 22.6615 16.3138 22.1363C15.9201 21.6114 15.6943 20.9137 15.6943 20.1686C15.6943 19.4235 15.9201 18.7258 16.3138 18.2009Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureSmall);
export default __webpack_public_path__ + "static/media/secure-small.d43c847e.svg";
export { ForwardRef as ReactComponent };